import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DigitalMarketingRoutingModule } from './digital-marketing-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DigitalMarketingRoutingModule
  ]
})
export class DigitalMarketingModule { }
